export enum AdminPageTypeActionTypes {
  PAGE_TYPE_UPDATE_REQUEST = 'admin-page-type/PAGE_TYPE_UPDATE_REQUEST',
  PAGE_TYPE_UPDATE_SUCCESS = 'admin-page-type/PAGE_TYPE_UPDATE_SUCCESS',
  PAGE_TYPE_UPDATE_ERROR = 'admin-page-type/PAGE_TYPE_UPDATE_ERROR',
}
